import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Topbar from "@/components/Topbar";
import { Briefcase, Users, Plus } from "@phosphor-icons/react";

/* v2.88 · Client landing dashboard.
   Minimal P0 shell — job posting form + PE directory arrive in P1/P2. */
export default function ClientDashboard() {
  const { user } = useAuth();
  return (
    <div className="industrial min-h-screen bg-[#0A0C10]">
      <Topbar active="dashboard" />
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-10">
        <div className="label-tag">// client workspace</div>
        <h1 className="font-display text-4xl md:text-5xl font-black mt-1">
          Welcome{user?.name ? `, ${user.name.split(" ")[0]}` : ""}.
        </h1>
        <p className="text-gray-400 mt-2">Post an engineering project or browse the directory of licensed engineers.</p>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
          <Link to="/directory" className="border border-white/10 hover:border-[#00E5FF]/60 p-6 bg-[#12151C] transition group"
                data-testid="client-tile-directory">
            <Users size={28} weight="duotone" className="text-[#00E5FF]" />
            <div className="label-tag mt-3">// step 1 · discover</div>
            <h3 className="font-display text-2xl font-bold mt-1 group-hover:text-[#00E5FF] transition">Browse engineers</h3>
            <p className="text-sm text-gray-400 mt-2">
              Filter the vetted directory by country, state, years of practice, and specialization.
            </p>
            <div className="mt-4 text-xs font-mono text-[#00E5FF]">Open directory →</div>
          </Link>
          <Link to="/jobs/new" className="border border-white/10 hover:border-[#00E5FF]/60 p-6 bg-[#12151C] transition group"
                data-testid="client-tile-post-job">
            <div className="w-10 h-10 bg-[#00E5FF] flex items-center justify-center">
              <Plus size={22} weight="bold" className="text-black" />
            </div>
            <div className="label-tag mt-3">// step 2 · post</div>
            <h3 className="font-display text-2xl font-bold mt-1 group-hover:text-[#00E5FF] transition">Post a project</h3>
            <p className="text-sm text-gray-400 mt-2">
              Describe scope, budget, deadline. Vetted engineers submit RFP-style proposals.
            </p>
            <div className="mt-4 text-xs font-mono text-[#00E5FF]">Open form →</div>
          </Link>
        </div>

        <div className="mt-10 border border-white/10 bg-white/5 p-4 text-xs font-mono text-gray-400 flex items-center gap-2"
             data-testid="client-info-banner">
          <Briefcase size={16} className="text-gray-500" />
          Jobs and the engineer directory are now live. Chat, proposal review, and multi-milestone tracking are all inside the Job detail page.
        </div>
      </div>
    </div>
  );
}
